module.exports = __webpack_public_path__ + "img/salesman_joinBtn.1b6b3a62.png";